module.exports = __webpack_public_path__ + "assets/media/moreMenu-instagram.26701e96.svg";